/* eslint-disable react/prop-types */

import React  from 'react';

import { observer } from 'mobx-react';

import { ButtonGroup, Button } from 'react-bootstrap';

const TaskStateSelect = observer(({ taskStore, rowData, value, onError }) => {
    const defaultVariant = 'secondary';
    const variants = { [value]: 'info'  };

    const handleClick = newState => {
        taskStore.updateTaskState(rowData.id, newState).catch(err => onError(err.toString()));
    };

    return <ButtonGroup aria-label='Task State'>
        <Button size='sm' onClick={() => handleClick('requested')} variant={variants.requested || defaultVariant}>Requested</Button>
        <Button size='sm' onClick={() => handleClick('completed')} variant={variants.completed || defaultVariant}>Completed</Button>
    </ButtonGroup>;
});

export { TaskStateSelect };
